export default __webpack_public_path__ + "static/media/Communication.83b85391.webp";